import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "list", "view", "viewCard", "viewTitle", "mainCard", "bodyTable", "footerTable", "submenu", "addNewLeadBtn"]

  connect() {
    this.controllerName = `commercial--sales--leads--sources--landings`
    this.itemsOnPage = 100
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `desc`, field: `date_to_time` }
    this.doIndexListHtml()
  }

  addSQL(ev) {
    var leadId = ev.currentTarget.closest(".itemRow").dataset.id
    var lead = {}

    this.leads.forEach(element => {
      if (element.id == leadId) {
        lead = element
      }
    })

    this.getControllerByIdentifier("commercial--sales--leads--sources--save-lead").current_lead = lead
    this.getControllerByIdentifier("commercial--sales--leads--sources--save-lead").doFormHtml()
  }

  goToOpportunity(ev) {
    var url = ev.target.closest(".itemRow").dataset.opportunityPath
    window.open(url, `_blank`)
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Leads de Landings</h6>
                    <input class="form-control s-title-0p7rem w-50 mr-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                  </div>
                  <div class="card-body px-1 py-0 card-overflow">
                    <div class="row">
                      <div class="col p-0">
                        <div class="table-responsive mc-table-responsive">
                          <table class="table table-sm table-hover" style="font-size:80%;" data-app--helpers--search-target="searchTable">
                            <thead>
                              <tr>
                                <th style="font-size:80%;" scope="col" class="p-1 table-20 align-middle pointer">
                                  Data
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="date_to_time" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="date_to_time" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="p-1 table-30 align-middle pointer">
                                  Nome
                                  <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="desc">south</span>
                                  <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="asc">north</span>
                                </th>
                                <th style="font-size:80%;" scope="col" class="p-1 table-20 align-middle">Conselho</th>                             
                                <th style="font-size:80%;" scope="col" class="p-1 table-3 align-middle text-center">SQL</th>
                                <th style="font-size:80%;" scope="col" class="p-1 table-3 align-middle text-center"></th>
                                <th style="font-size:80%;" scope="col" class="p-1 table-3 align-middle text-center"></th>
                              </tr>
                            </thead>
                            <tbody data-${this.controllerName}-target="bodyTable">
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.5) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(6, 4))
      
      if (controller.application.landing_leads.length > 0) {
        controller.doDataTable()
      } else {
        controller.getControllerByIdentifier(`commercial--sales--leads--sources--dashboard`).getLandingLeads()
      }
    })
  }

  doDataTable() {
    this.leads = this.application.landing_leads

    if (this.sort.mode == `asc`) {
      var leads = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(this.leads, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var leads = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(this.leads, this.sort.field)
    }

    if (leads.length == 0) {
      this.listData()
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(leads.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (leads[x] !== undefined) {
            internPage[internPage.length] = leads[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: leads.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="6" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Leads Gerados</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.leadTablePartial(element, data.length))
      });
    }
  }

  leadTablePartial(element, length) {


    if (element.sql) {
      var actionBtn = ``
      var sqlIcon = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-primary">done_all</span>
                        <span class="mc-tooltiptext">Já é SQL</span>
                      </span>`
    } else if (this.application.permissions.sales_qualified_leads.can_create) {
      var actionBtn = `<button data-action="click->${this.controllerName}#addSQL" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                        <span class="material-icons md-sm md-dark">add_circle_outline</span>
                        <span class="mc-tooltiptext">Gerar SQL</span>
                      </button>`
      var sqlIcon = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-warning">new_releases</span>
                        <span class="mc-tooltiptext">Potencial SQL</span>
                      </span>`
    } else {
      var actionBtn = ``
      var sqlIcon = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-warning">new_releases</span>
                        <span class="mc-tooltiptext">Potencial SQL</span>
                      </span>`
    }

    var searchBtn = `<button data-action="click->${this.controllerName}#searchCRM" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                        <span class="material-icons md-sm md-dark">search</span>
                        <span class="mc-tooltiptext">Procurar CRM</span>
                      </button>`

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    if (element.name == undefined || element.name == null) {
      element.name = `Não Fornecido`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.created_at_pretty} | ${element.created_at_time_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.council_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer">${sqlIcon}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 px-0 align-middle pointer">${actionBtn}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 px-0 align-middle pointer">${searchBtn}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="card-actions align-items-center justify-content-end py-0 f-065">
                        <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                        <div class="dropdown">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${pagination.itemsOnPage}</button>
                          <div class="dropdown-menu dropdown-menu-right menu">
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="100">100</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="500">500</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                          </div>
                        </div>
                        <span class="align-self-center mb-1 mr-2 text-muted">${pagination.fromItem}-${pagination.toItem} de ${pagination.totalItems}</span>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  searchCRM(ev) {
    var sqlId = ev.currentTarget.closest(".itemRow").dataset.id

    var lead = {}
    this.leads.forEach(element => {
      if (element.id == sqlId) {
        lead = element
      }
    })

    if (lead.crm && lead.crm_state) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=&uf=${lead.crm_state}&crm=${lead.crm}&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.crm) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=&uf=&crm=${lead.crm}&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.name && lead.crm_state) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=${lead.name}&uf=${lead.crm_state}&crm=&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    } else if (lead.name) {
      var url = `https://portal.cfm.org.br/busca-medicos/?nome=${lead.name}&uf=&crm=&pageNumber=1&pageSize=100`
      window.open(url, `_blank`)
    }

    // const url = "https://portal.cfm.org.br/busca-medicos/?nome=&uf=MG&crm=84779&municipio=&inscricao=&tipoSituacao=&situacao=&especialidade=&areaAtuacao=&pageNumber=1&pageSize=100"
    // const url = "https://portal.cfm.org.br/busca-medicos/?nome=&uf=MG&crm=84779&pageNumber=1&pageSize=100"
    // window.open(url, `_blank`)
  }

  getLeads() {
    const data = { lead: { active: true }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/commercial/marketing/leads/generations/list_landings"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        this.leads = response.data.cln
        controller.doDataTable()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = "operations--products--tax-filings--entities--index"
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
